module.exports = __webpack_public_path__ + "img/facility13.67a43290.jpg";